import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { WITH_CREDENTIALS } from '@vapor/angular-sdk';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class HeaderCorsInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(
      request.clone({
        setHeaders: {
          'Access-Control-Allow-Origin': '*',
        },
        withCredentials: request.context.get(WITH_CREDENTIALS),
      }),
    );
  }
}
